type Props = {
  eyebrow: string;
  title: React.ReactNode;
  aside?: string;
  /** "center" for the centred variant, "split" to float `aside` to the right. */
  variant?: "start" | "center" | "split";
  eyebrowTone?: "orange" | "blue";
  id?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  aside,
  variant = "start",
  eyebrowTone = "orange",
  id,
}: Props) {
  const modifier = variant === "start" ? "" : ` ss-heading--${variant}`;

  return (
    <div className={`ss-heading${modifier}`}>
      <div>
        <p
          className={`ss-eyebrow${eyebrowTone === "blue" ? " ss-eyebrow--blue" : ""}`}
        >
          {eyebrow}
        </p>
        <h2 className="ss-h2 ss-heading__title" id={id}>
          {title}
        </h2>
      </div>
      {aside ? <p className="ss-heading__aside">{aside}</p> : null}
    </div>
  );
}
